"use strict";
/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_KEY = exports.fetchGetApiIntroducerPortalDirectorSearch = exports.GET_API_INTRODUCER_PORTAL_DIRECTOR_SEARCH_KEY = exports.fetchPostApiIntroducerPortalApplicationRefresh = exports.POST_API_INTRODUCER_PORTAL_APPLICATION_REFRESH_KEY = exports.fetchPutApiIntroducerPortalApplication = exports.PUT_API_INTRODUCER_PORTAL_APPLICATION_KEY = exports.fetchPostApiIntroducerPortalApplication = exports.POST_API_INTRODUCER_PORTAL_APPLICATION_KEY = exports.fetchGetApiIntroducerPortalApplication = exports.GET_API_INTRODUCER_PORTAL_APPLICATION_KEY = exports.fetchPostApiIntroducerPortalIntroducerWhatsNew = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_WHATS_NEW_KEY = exports.fetchGetApiIntroducerPortalIntroducerWhatsNew = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_WHATS_NEW_KEY = exports.fetchGetApiIntroducerPortalIntroducerNotificationSubscription = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_NOTIFICATION_SUBSCRIPTION_KEY = exports.fetchGetApiIntroducerPortalIntroducerNotification = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_NOTIFICATION_KEY = exports.fetchPostApiIntroducerPortalIntroducerApplicationRejectOffers = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_REJECT_OFFERS_KEY = exports.fetchPostApiIntroducerPortalIntroducerApplicationOfferAccept = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_ACCEPT_KEY = exports.fetchPostApiIntroducerPortalIntroducer = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_KEY = exports.fetchGetApiIntroducerPortalIntroducer = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationRejectOfferReasons = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_REJECT_OFFER_REASONS_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferAllowedWithdrawalFeeRates = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_ALLOWED_WITHDRAWAL_FEE_RATES_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_DRAW_DOWN_REPAYMENT_SCHEDULE_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferFundingRequirements = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_FUNDING_REQUIREMENTS_KEY = exports.fetchGetApiIntroducerPortalIntroducerContextByIntroducerId = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_CONTEXT_BY_INTRODUCER_ID_KEY = exports.fetchGetApiIntroducerPortalIntroducerContext = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_CONTEXT_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationOffers = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFERS_KEY = exports.fetchPutApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate = exports.PUT_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = exports.fetchPostApiIntroducerPortalIntroducerAccount = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_ACCOUNT_KEY = exports.LapiError = exports.fetchLendingAPIJSON = exports.fetchLendingAPI = void 0;
exports.fetchGetApiIntroducerPortalRepaymentSimulator = exports.GET_API_INTRODUCER_PORTAL_REPAYMENT_SIMULATOR_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationCustomerContactUpdates = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_CUSTOMER_CONTACT_UPDATES_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationTemp = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_TEMP_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationDeclineReason = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_DECLINE_REASON_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferExpectedCommission = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_EXPECTED_COMMISSION_KEY = exports.fetchPostApiIntroducerPortalIntroducerApplicationRefresh = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_REFRESH_KEY = exports.fetchPostApiIntroducerPortalIntroducerStateApplication = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_STATE_APPLICATION_KEY = exports.fetchPostApiIntroducerPortalIntroducerCustomerApplication = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_CUSTOMER_APPLICATION_KEY = exports.fetchPutApiIntroducerPortalIntroducerApplication = exports.PUT_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplication = void 0;
const lendingAPI_1 = require("./lendingAPI");
var lendingAPI_2 = require("./lendingAPI");
Object.defineProperty(exports, "fetchLendingAPI", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPI; } });
Object.defineProperty(exports, "fetchLendingAPIJSON", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPIJSON; } });
Object.defineProperty(exports, "LapiError", { enumerable: true, get: function () { return lendingAPI_2.LapiError; } });
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_ACCOUNT_KEY = "postApiIntroducerPortalIntroducerAccount";
/**
 * Create a new introducer account and an introducer belonging to that account
 */
function fetchPostApiIntroducerPortalIntroducerAccount({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/account/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducerAccount = fetchPostApiIntroducerPortalIntroducerAccount;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = "getApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate";
/**
 * Returns the currently configured withdrawal fee for an offer
 */
function fetchGetApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate({ introducerId, applicationId, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate = fetchGetApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate;
exports.PUT_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = "putApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate";
/**
 * Update the currently configured withdrawal fee for an offer
 */
function fetchPutApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate({ introducerId, applicationId, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, {
        method: "put",
        body,
    });
}
exports.fetchPutApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate = fetchPutApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFERS_KEY = "getApiIntroducerPortalIntroducerApplicationOffers";
/**
 * Get available offers for an application with any relevant data requirements
 */
function fetchGetApiIntroducerPortalIntroducerApplicationOffers({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offers/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationOffers = fetchGetApiIntroducerPortalIntroducerApplicationOffers;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_CONTEXT_KEY = "getApiIntroducerPortalIntroducerContext";
/**
 * Get introducer context for a logged in introducer when not impersonating
 */
function fetchGetApiIntroducerPortalIntroducerContext({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/context/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerContext = fetchGetApiIntroducerPortalIntroducerContext;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_CONTEXT_BY_INTRODUCER_ID_KEY = "getApiIntroducerPortalIntroducerContextByIntroducerId";
/**
 * Get introducer context when impersonating by passing in the relevant introducer UUID
 */
function fetchGetApiIntroducerPortalIntroducerContextByIntroducerId({ introducerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/context/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerContextByIntroducerId = fetchGetApiIntroducerPortalIntroducerContextByIntroducerId;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_FUNDING_REQUIREMENTS_KEY = "getApiIntroducerPortalIntroducerApplicationOfferFundingRequirements";
/**
 * Get funding requirements for the broker agreed formal offer on an application
 */
function fetchGetApiIntroducerPortalIntroducerApplicationOfferFundingRequirements({ introducerId, applicationId, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/funding_requirements/`, {
        method: "get",
        query,
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferFundingRequirements = fetchGetApiIntroducerPortalIntroducerApplicationOfferFundingRequirements;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_DRAW_DOWN_REPAYMENT_SCHEDULE_KEY = "getApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule";
/**
 * Generate a repayment schedule for an existing formal offer.
 */
function fetchGetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule({ introducerId, applicationId, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/draw_down_repayment_schedule/`, {
        method: "get",
        query,
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule = fetchGetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_ALLOWED_WITHDRAWAL_FEE_RATES_KEY = "getApiIntroducerPortalIntroducerApplicationOfferAllowedWithdrawalFeeRates";
/**
 * Get an array of allowed withdrawal fee rates for an offer which satisfy APR contraints and offer adjustability rules
 */
function fetchGetApiIntroducerPortalIntroducerApplicationOfferAllowedWithdrawalFeeRates({ introducerId, applicationId, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/allowed_withdrawal_fee_rates/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferAllowedWithdrawalFeeRates = fetchGetApiIntroducerPortalIntroducerApplicationOfferAllowedWithdrawalFeeRates;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_REJECT_OFFER_REASONS_KEY = "getApiIntroducerPortalIntroducerApplicationRejectOfferReasons";
/**
 * If an offer is rejected, return the supplied rejection reasons from the introducer or the customer
 */
function fetchGetApiIntroducerPortalIntroducerApplicationRejectOfferReasons({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/reject_offer_reasons/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationRejectOfferReasons = fetchGetApiIntroducerPortalIntroducerApplicationRejectOfferReasons;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_KEY = "getApiIntroducerPortalIntroducer";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducer({ introducerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducer = fetchGetApiIntroducerPortalIntroducer;
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_KEY = "postApiIntroducerPortalIntroducer";
/**
 * No description
 */
function fetchPostApiIntroducerPortalIntroducer({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducer = fetchPostApiIntroducerPortalIntroducer;
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_ACCEPT_KEY = "postApiIntroducerPortalIntroducerApplicationOfferAccept";
/**
 * Accept a single offer, updating the contact entity to CUSTOMER and selecting the offer for display to the customer. Optionally, with suggested contact details
 */
function fetchPostApiIntroducerPortalIntroducerApplicationOfferAccept({ introducerId, applicationId, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/accept/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducerApplicationOfferAccept = fetchPostApiIntroducerPortalIntroducerApplicationOfferAccept;
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_REJECT_OFFERS_KEY = "postApiIntroducerPortalIntroducerApplicationRejectOffers";
/**
 * Reject all available formal offers on an application and supply the reason
 */
function fetchPostApiIntroducerPortalIntroducerApplicationRejectOffers({ introducerId, applicationId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/reject_offers/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducerApplicationRejectOffers = fetchPostApiIntroducerPortalIntroducerApplicationRejectOffers;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_NOTIFICATION_KEY = "getApiIntroducerPortalIntroducerNotification";
/**
 * Get notifications for an introducer and an unread count (maximum 51)
 */
function fetchGetApiIntroducerPortalIntroducerNotification({ introducerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/notification/`, {
        method: "get",
        query,
    });
}
exports.fetchGetApiIntroducerPortalIntroducerNotification = fetchGetApiIntroducerPortalIntroducerNotification;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_NOTIFICATION_SUBSCRIPTION_KEY = "getApiIntroducerPortalIntroducerNotificationSubscription";
/**
 * Get a list of notifications statuses an introducer is subscribed to.
 */
function fetchGetApiIntroducerPortalIntroducerNotificationSubscription({ introducerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/notification/subscription/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerNotificationSubscription = fetchGetApiIntroducerPortalIntroducerNotificationSubscription;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_WHATS_NEW_KEY = "getApiIntroducerPortalIntroducerWhatsNew";
/**
 * Get what&#x27;s new posts.
 */
function fetchGetApiIntroducerPortalIntroducerWhatsNew({ introducerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/whats_new/`, {
        method: "get",
        query,
    });
}
exports.fetchGetApiIntroducerPortalIntroducerWhatsNew = fetchGetApiIntroducerPortalIntroducerWhatsNew;
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_WHATS_NEW_KEY = "postApiIntroducerPortalIntroducerWhatsNew";
/**
 * Mark all what&#x27;s new posts as read for an introducer.
 */
function fetchPostApiIntroducerPortalIntroducerWhatsNew({ introducerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/whats_new/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducerWhatsNew = fetchPostApiIntroducerPortalIntroducerWhatsNew;
exports.GET_API_INTRODUCER_PORTAL_APPLICATION_KEY = "getApiIntroducerPortalApplication";
/**
 * Get application by state key.
 */
function fetchGetApiIntroducerPortalApplication({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/application/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalApplication = fetchGetApiIntroducerPortalApplication;
exports.POST_API_INTRODUCER_PORTAL_APPLICATION_KEY = "postApiIntroducerPortalApplication";
/**
 * Create new application for a state key
 */
function fetchPostApiIntroducerPortalApplication({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/application/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalApplication = fetchPostApiIntroducerPortalApplication;
exports.PUT_API_INTRODUCER_PORTAL_APPLICATION_KEY = "putApiIntroducerPortalApplication";
/**
 * Update application for a state key
 */
function fetchPutApiIntroducerPortalApplication({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/application/${stateKey}/`, {
        method: "put",
        body,
    });
}
exports.fetchPutApiIntroducerPortalApplication = fetchPutApiIntroducerPortalApplication;
exports.POST_API_INTRODUCER_PORTAL_APPLICATION_REFRESH_KEY = "postApiIntroducerPortalApplicationRefresh";
/**
 * Refresh an application for a state key
 */
function fetchPostApiIntroducerPortalApplicationRefresh({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/application/${stateKey}/refresh/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalApplicationRefresh = fetchPostApiIntroducerPortalApplicationRefresh;
exports.GET_API_INTRODUCER_PORTAL_DIRECTOR_SEARCH_KEY = "getApiIntroducerPortalDirectorSearch";
/**
 * Search for directors and beneficial owners of a company by company number and return details
 */
function fetchGetApiIntroducerPortalDirectorSearch({ companyNumber, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/director_search/${companyNumber}/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalDirectorSearch = fetchGetApiIntroducerPortalDirectorSearch;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_KEY = "getApiIntroducerPortalIntroducerApplication";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerApplication({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplication = fetchGetApiIntroducerPortalIntroducerApplication;
exports.PUT_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_KEY = "putApiIntroducerPortalIntroducerApplication";
/**
 * No description
 */
function fetchPutApiIntroducerPortalIntroducerApplication({ introducerId, applicationId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/`, {
        method: "put",
        body,
    });
}
exports.fetchPutApiIntroducerPortalIntroducerApplication = fetchPutApiIntroducerPortalIntroducerApplication;
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_CUSTOMER_APPLICATION_KEY = "postApiIntroducerPortalIntroducerCustomerApplication";
/**
 * No description
 */
function fetchPostApiIntroducerPortalIntroducerCustomerApplication({ introducerId, customerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/customer/${customerId}/application/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducerCustomerApplication = fetchPostApiIntroducerPortalIntroducerCustomerApplication;
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_STATE_APPLICATION_KEY = "postApiIntroducerPortalIntroducerStateApplication";
/**
 * No description
 */
function fetchPostApiIntroducerPortalIntroducerStateApplication({ introducerId, stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/state/${stateKey}/application/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducerStateApplication = fetchPostApiIntroducerPortalIntroducerStateApplication;
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_REFRESH_KEY = "postApiIntroducerPortalIntroducerApplicationRefresh";
/**
 * No description
 */
function fetchPostApiIntroducerPortalIntroducerApplicationRefresh({ introducerId, applicationId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/refresh/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducerApplicationRefresh = fetchPostApiIntroducerPortalIntroducerApplicationRefresh;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_EXPECTED_COMMISSION_KEY = "getApiIntroducerPortalIntroducerApplicationOfferExpectedCommission";
/**
 * Get the estimated maximum expected commission amount and rate for an offer
 */
function fetchGetApiIntroducerPortalIntroducerApplicationOfferExpectedCommission({ introducerId, applicationId, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/expected_commission/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferExpectedCommission = fetchGetApiIntroducerPortalIntroducerApplicationOfferExpectedCommission;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_DECLINE_REASON_KEY = "getApiIntroducerPortalIntroducerApplicationDeclineReason";
/**
 * Returns the most important credit assessment decline reason or default copy for approaval requirement declines.
 */
function fetchGetApiIntroducerPortalIntroducerApplicationDeclineReason({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/decline_reason/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationDeclineReason = fetchGetApiIntroducerPortalIntroducerApplicationDeclineReason;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_TEMP_KEY = "getApiIntroducerPortalIntroducerApplicationTemp";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerApplicationTemp({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/temp/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationTemp = fetchGetApiIntroducerPortalIntroducerApplicationTemp;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_CUSTOMER_CONTACT_UPDATES_KEY = "getApiIntroducerPortalIntroducerApplicationCustomerContactUpdates";
/**
 * Get latest updates on iwoca contact with a customer about an application.
 */
function fetchGetApiIntroducerPortalIntroducerApplicationCustomerContactUpdates({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/customer_contact_updates/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationCustomerContactUpdates = fetchGetApiIntroducerPortalIntroducerApplicationCustomerContactUpdates;
exports.GET_API_INTRODUCER_PORTAL_REPAYMENT_SIMULATOR_KEY = "getApiIntroducerPortalRepaymentSimulator";
/**
 * Generate a simulated repayment schedule without a formal offer. Used for the standalone calculator
 */
function fetchGetApiIntroducerPortalRepaymentSimulator({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/introducer_portal/repayment_simulator/`, {
        method: "get",
        query,
    });
}
exports.fetchGetApiIntroducerPortalRepaymentSimulator = fetchGetApiIntroducerPortalRepaymentSimulator;
